import { PatientInfoMapper } from "@/data/mapper/patient/patient-info-mapper";
import { PatientListInfoMapper } from "@/data/mapper/patient/patient-list-info-mapper";
import { safeMapToEntity } from "@/data/repo-Implement/safe-map-to-entity";
import { UpdatePatientInfoRequestPayload } from "@/data/payload/patient/update-paitent-info-request-payload";
import { ResendSMSForSetupAccountRequestPayload } from "@/data/payload/user/re-send-sms-for-setup-account-request-payload";
import { PatientSource } from "@/data/source/patient-source";
import { UserSource } from "@/data/source/user-source";
import { PatientTableInfoEntity } from "@/domain/entity/patient/patient-table-info-entity";
import { PatientRepository } from "@/domain/repository/patient-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class PatientRepositoryImpl implements PatientRepository {
  constructor(
    private readonly patientSource: PatientSource,
    private readonly userSource: UserSource
  ) {}

  async fetchPatientList(): Promise<SATResult<PatientTableInfoEntity[], SATError>> {
    const result = await this.patientSource.fetchPatientList();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return safeMapToEntity(
      result.value,
      PatientListInfoMapper.toEntity,
      "PatientRepositoryImpl::fetchPatientList"
    );
  }

  async fetchPatient(
    patientUuid: string
  ): Promise<SATResult<PatientTableInfoEntity, SATError>> {
    const result = await this.patientSource.fetchPatient(patientUuid);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return safeMapToEntity(
      result.value,
      PatientInfoMapper.toEntity,
      "PatientRepositoryImpl::fetchPatient"
    );
  }

  async updatePatientInfo(
    payload: UpdatePatientInfoRequestPayload
  ): Promise<SATResult<void, SATError>> {
    const result = await this.patientSource.updatePatientInfo(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async activatePatient(patientUuid: string): Promise<SATResult<void, SATError>> {
    const result = await this.patientSource.activatePatient(patientUuid);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async deactivatePatient(patientUuid: string): Promise<SATResult<void, SATError>> {
    const result = await this.patientSource.deactivatePatient(patientUuid);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async resendSMSForSetupAccount(
    payload: ResendSMSForSetupAccountRequestPayload
  ): Promise<SATResult<void, SATError>> {
    const result = await this.userSource.resendSMSForSetupAccount(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(undefined);
  }
}
